import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetDefaultCarOptions'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetDefaultCarOptionsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetDefaultCarOptionsStore",
			variables: false,
		})
	}
}

export async function load_GetDefaultCarOptions(params) {
  await initClient()

	const store = new GetDefaultCarOptionsStore()

	await store.fetch(params)

	return {
		GetDefaultCarOptions: store,
	}
}
